<template>
  <div>
    <header class="modal-header">
      <h3 class="modal-title">{{mode + ' User Roles'}}</h3>
    </header>
    <div class="modal-body">
      <b-form>
        <b-form-group
          label="CODE:"
          label-for="code"
          v-show="mode === 'Edit'">
          <b-form-input
            id="code"
            type="text"
            v-model="userState.CODE"
            disabled
            required>
          </b-form-input>
        </b-form-group>
        <b-form-group
          label="COUNTER:"
          label-for="counter">
          <b-form-input
            id="counter"
            type="text"
            v-model="userState.COUNTER"
            required>
          </b-form-input>
        </b-form-group>
      </b-form>
    </div>
    <footer class="modal-footer">
      <b-btn :size="'sm'" @click="$emit('close')">Cancel</b-btn>
      <b-btn :variant="'primary'" :size="'sm'" @click="handleSubmit" :disabled="isFetching">Submit</b-btn>
    </footer>
  </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import server from '@/services/server'

export default {
  name: 'user-roles-modal',
  props: {
    mode: String,
    model: Object
  },
  data () {
    return {
      userState: { ...this.model } || {},
      isFetching: false
    }
  },
  components: {
    cSwitch
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.isFetching = true
      let payload = [{
        code: this.userState.CODE,
        name: this.userState.NAME,
        status: this.getStatus ? 1 : 0
      }]

      server.post('/upsertuserStates', payload).then(
        resp => {
          this.isFetching = false
          this.$emit('close')
        },
        err => {
          this.isFetching = false
        }
      )
    }
  },
  computed: {
    getStatus () {
      if (this.userState) {
        return this.userState.STATUS ? true : false
      } else {
        return false
      }

    }
  }
}
</script>
